import React from "react";
import { Route, useRouteMatch } from "react-router-dom";
import classnames from "classnames";
import ErrorBoundary from "./components/pages/ErrorBoundary";
import { ToastContainer } from "react-toastify";
import PageContainer from "@ignitesales/neuro-application/src/components/PageContainer";
import { connect } from "react-redux";
import LandingPage from "./components/pages/LandingPage";
import SurveyPage from "./components/pages/SurveyPage";
import SummaryPage from "./components/pages/SummaryPage";
import DetailsPage from "./components/pages/DetailsPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GuideContext from "./GuideContext";
import AppContainer from "@ignitesales/neuro-application/src/components/AppContainer";
import TransitionContainer from "@ignitesales/neuro-application/src/components/TransitionContainer";
import { FormattedMessage } from "react-intl";

const App = ({
  isBranchGuide,
  isBusinessGuide,
  pathClassName,
  pageClassName,
  location,
  logout,
  user
}) => {
  const pageContainerClasses = classnames(
    "pageContainer",
    pathClassName,
    pageClassName
  );
  const context = {
    isBranchGuide,
    isBusinessGuide,
  };
  const matchSurvey = useRouteMatch('/guide/spa');

  return (
    <GuideContext.Provider value={context}>
      <AppContainer ErrorBoundary={ErrorBoundary} location={location}>
        <Header />
        <Route
          render={(props) => (
            <PageContainer
              {...props}
              LandingPage={LandingPage}
              SurveyPage={SurveyPage}
              SummaryPage={SummaryPage}
              DetailsPage={DetailsPage}
              render={({route}) => {
                const classes = classnames('pageContainer', pathClassName, pageClassName);
                return <TransitionContainer timeout={350} className={classes} transitionKey={location.key}>
                  { route }
                </TransitionContainer>;
              }}
            />
          )}
        ></Route>
        {!matchSurvey && <Footer isBusinessGuide={isBusinessGuide} location={location} logout={logout} user={user} text={<FormattedMessage id="copyright" />} />}

        <ToastContainer />
      </AppContainer>
    </GuideContext.Provider>
  );
};

export default connect((state, { location }) => {
  const page = state.pages[location.pathname] || {};
  return {
    location,
    page,
    pathClassName: page.path ? `path--${page.path.key}` : "",
    pageClassName: page.page ? `page--${page.page.key}` : "",
  };
})(App);
